export { default, SEARCH_WRAPPER_ID } from './MainHeader';
